/**
 * stripLatLng — search-param reducer that removes the coordinate-search
 * deep-link `lat`/`lng` params from the URL while preserving every other
 * search param (including `zoom`).
 *
 * A `lat`/`lng` deep link (catalog "open on map" / POI "show on map") must
 * only win over a restored `viewBbox` for the single navigation that carries
 * it. Once MapPage has seeded its initial marker/camera from them, they are
 * stripped so `setMapBbox`'s `{ ...prev, viewBbox: bbox }` search reducer
 * (see use-map-page-state.ts) doesn't keep re-persisting a stale `lat`/`lng`
 * on every later pan/zoom — which would permanently block `viewBbox` restore
 * on every subsequent mount for the rest of the session (CU-86cb1nq31).
 */
export function stripLatLng<T extends { lat?: unknown; lng?: unknown }>(
  prev: T,
): Omit<T, 'lat' | 'lng'> {
  const rest = { ...prev };
  delete rest.lat;
  delete rest.lng;
  return rest;
}
